export const TAXES_DATA_KEYS = [
  {
    key: 'city_tax_amount',
    translation: 'City TAX',
  },
  {
    key: 'county_tax_amount',
    translation: 'County TAX',
  },
  {
    key: 'local_tax_amount',
    translation: 'Local TAX',
  },
  {
    key: 'sec_county_tax_amount',
    translation: 'Sec county TAX',
  },
  {
    key: 'sec_local_tax_amount',
    translation: 'Sec local TAX',
  },
  {
    key: 'state_tax_amount',
    translation: 'State TAX',
  },
  {
    key: 'waste_tax_amount',
    translation: 'Waste TAX',
  },
] as const;

export const DELIVERY_TAXES_KEYS = [
  {
    key: 'delivery_fees',
    translation: 'Delivery Fees',
  },
  {
    key: 'delivery_local_tax',
    translation: 'Delivery Local TAX',
  },
] as const;

export const RATES_TAXES_DATA_KEYS = [
  {
    key: 'city_tax_rate',
    translation: 'City TAX rate',
  },
  {
    key: 'county_tax_rate',
    translation: 'County TAX rate',
  },
  {
    key: 'local_tax_rate',
    translation: 'Local TAX rate',
  },
  {
    key: 'sec_county_tax_rate',
    translation: 'Sec county TAX rate',
  },
  {
    key: 'sec_local_tax_rate',
    translation: 'Sec local TAX rate',
  },
  {
    key: 'state_tax_rate',
    translation: 'State TAX rate',
  },
] as const;

export const TOTAL_TAXES_DATA_KEYS = [
  {
    key: 'total_city_tax_amount',
    translation: 'City TAX amount',
  },
  {
    key: 'total_county_tax_amount',
    translation: 'County TAX amount',
  },
  {
    key: 'total_local_tax_amount',
    translation: 'Local TAX amount',
  },
  {
    key: 'total_sec_county_tax_amount',
    translation: 'Sec county TAX amount',
  },
  {
    key: 'total_sec_local_tax_amount',
    translation: 'Sec local TAX amount',
  },
  {
    key: 'total_state_tax_amount',
    translation: 'State TAX amount',
  },
  {
    key: 'total_waste_tax_amount',
    translation: 'Waste TAX amount',
  },
] as const;
